import PropTypes from "prop-types";

export const MaterialFieldItem = PropTypes.shape({
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
});
